/**
 * @file Element counter class that handles a global counter which is incremeneted
 *    everytime an element is created. This ensures unique IDs
 */

export class ElementCounter {
  private _value: number;

  constructor() {
    this._value = -1;
  }

  /**
   * Getter for the counter value, increment automatically everytime it is requested.
   */
  public get value(): string {
    this._value++;
    return this._value.toString();
  }

  /**
   * Setter for the counter value. Set on importing from JSON.
   */
  public set value(newValue: string) {
    this._value = parseInt(newValue);
  }

  /**
   * 重置计数器（新建本体图时调用）
   */
  public reset() {
    this._value = -1;
  }
}

export const eleCounter = new ElementCounter();
